import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";

const tabList = ["All"];
const AllPortfolioContent = [
  {
    img: "workshop",
    title: "Training teachers in-person and remotely",
    subTitle: "",
    alterText: "Phil facilitates workshops",
    delayAnimation: "",
    portfolioLink:
      "",
  },
  {
    img: "mfa2",
    title: "Facilitating a mini-course at Math For America",
    subTitle: "",
    alterText: "Math for America",
    delayAnimation: "100",
    portfolioLink:
      "",
  },
  {
    img: "fordham",
    title: "Students in my graduate class working collaboratively on a problem",
    subTitle: "",
    alterText: "Students working",
    delayAnimation: "200",
    portfolioLink:
      "",
  },
  {
    img: "firstyear",
    title: "Transforming my classroom into a coordinate grid in my first years of teaching",
    subTitle: "",
    alterText: "First years teaching",
    delayAnimation: "0",
    portfolioLink:
      "",
  },
];

const PortfolioAnimation = () => {
  return (
    <div className="positon-relative">
        <div className="portfolio-filter-01">
          <Tabs>
            <TabList className="filter d-none justify-content-center">
              {tabList.map((val, i) => (
                <Tab key={i}>{val}</Tab>
              ))}
            </TabList>
            {/* End tablist */}

            <SRLWrapper>
              <TabPanel>
                <div className="portfolio-content row lightbox-gallery">
                  {AllPortfolioContent.map((val, i) => (
                    <div
                      className="col-6 grid-item product"
                      key={i}
                      data-aos="fade-right"
                      data-aos-duration="1200"
                      data-aos-delay={val.delayAnimation}
                    >
                      <div className="portfolio-box-01">
                        <div className="portfolio-img">
                          <div className="portfolio-info">
                            <h5>{val.title}</h5>
                          </div>
                          {/* End .portfolio-info */}
                          <a
                            href={`img/portfolio/${val.img}.jpg`}
                            className="gallery-link"
                          >
                            <img
                              src={`img/portfolio/${val.img}.jpg`}
                              alt={val.alterText}
                            />
                          </a>
                          {/* End gallery link */}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {/* End list wrapper */}
              </TabPanel>
            </SRLWrapper>
            {/* End tabpanel */}
          </Tabs>
        </div>
      </div>
  );
};

export default PortfolioAnimation;
